(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuSearchController', OnuSearchController);

    OnuSearchController.$inject = ['$scope', '$stateParams', '$state', '$timeout', 'OnuData', 'OnuService', 'OltService'];

    function OnuSearchController($scope, $stateParams, $state, $timeout, OnuData, OnuService, OltService) {
        var vm = this;
        vm.gponPortList = [
            {value: ''},
            {value: '1'},
            {value: '2'},
            {value: '3'},
            {value: '4'},
            {value: '5'},
            {value: '6'},
            {value: '7'},
            {value: '8'}
        ];

        vm.listOlts = [];
        vm.selected = {olt: null};
        vm.placeholder = {olt: ''};

        initialize();

        vm.ipTooltip = 'tooltip.ip.tip';

        vm.changeTooltip = function () {
            if (vm.formSearch.searchIp.$invalid) {
                vm.ipTooltip = 'tooltip.ip.invalid';
            } else {
                vm.ipTooltip = 'tooltip.ip.tip';
            }
        }

        vm.searchOnus = function () {
            if (vm.formSearch.$valid) {
                var data = angular.copy(vm.searchData);
                data.gponPort = vm.searchData.gponPort.value;
                if (vm.selected.olt) {
                    data.oltId = vm.selected.olt.id;
                }
                OnuData.search(data);
            }
        }

        vm.cleanFilter = function () {
            vm.searchData = {
                name: '',
                serialNumber: '',
                meProfile: '',
                olt: {value: ''},
                oltId: '',
                gponPort: {value: ''}
            };
            vm.selected.olt = vm.listOlts[0];
            OnuData.search();
        }

        function getOlts() {
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts({}, true).then(getOltSuccess).catch(getOltError);
            vm.selected.olt = vm.listOlts[0];
        }

        function getOltSuccess(data) {
            vm.listOlts = data;
            if (data.length) {
                vm.placeholder.olt = '';
                vm.listOlts.unshift({});
            } else {
                vm.placeholder.olt = 'provisioning.placeholder.noOltFound';
            }
            verifyParamsOlt();
        }

        function getOltError(response) {
            AlarmService.errorModalConstructor(response, 'getOltList');
        }
   
        function verifyParamsOlt() {
            if ($stateParams.name) {
                angular.forEach(vm.listOlts, function (item) {
                    if (item.name == $stateParams.name) {
                        vm.selected.olt = item;
                    }
                });
                if ($stateParams.port) {
                    vm.searchData.gponPort = vm.gponPortList[$stateParams.port];
                }
                var data = angular.copy(vm.searchData);
                data.gponPort = vm.searchData.gponPort.value;
                data.oltId = vm.selected.olt.id;
                OnuData.search(data);
            }   
        }

        function initialize() {
            vm.searchData = {
                name: '',
                serialNumber: '',
                meProfile: '',
                olt: {value: ''},
                oltId: '',
                gponPort: {value: ''}
            };
            getOlts();
           
        }
    }
})();